import { useMutation } from '@tanstack/react-query';
import { fetch4, fetch5 } from '../commonApis/commonApis';
const url = process.env.REACT_APP_BASE_URL;

interface CreateUserPayload {
  email: string;
  password: string;
  type: string
}

interface OtpPayload {
  email: string;
  otp: string;
}

interface ResendOtp {
  email: string;
}

export interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
  statusCode?: number;
  statusMessage?: string;
  error?: any;
}

export const useLoginMutation = () => {
  return useMutation({
    mutationFn: async (payload: CreateUserPayload) => {
      const res: ApiResponse = await fetch4(`${url}/api/auth/request-otp?type=lmClient`, payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || 'Something went wrong';
      }

      return res.data;
    },
    onSuccess: (data) => {
      console.log('✅ OTP requested successfully:', data);
    },
    onError: (error: any) => {
      console.error('❌ OTP request failed:', error.message);
    }
  });
};

export const useVerifyOTPMutation = () => {
  return useMutation({
    mutationFn: async (payload: OtpPayload) => {
      const res: ApiResponse = await fetch4(`${url}/api/auth/verify-otp?type=lmClient`, payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || 'Something went wrong';
      }

      return res.data;
    },
    onSuccess: (data) => {
      console.log('✅ OTP requested successfully:', data);
    },
    onError: (error: any) => {
      console.error('❌ OTP request failed:', error.message);
    }
  });
};


export const useResendOTPMutation = () => {
  return useMutation({
    mutationFn: async (payload: ResendOtp) => {
      const res: ApiResponse = await fetch4(`${url}/api/auth/resend-otp?type=lmClient`, payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || 'Something went wrong';
      }

      return res.data;
    },
    onSuccess: (data) => {
      console.log('✅ OTP requested successfully:', data);
    },
    onError: (error: any) => {
      console.error('❌ OTP request failed:', error.message);
    }
  });
};

export const useResetPasswordMutation = () => {
  return useMutation({
    mutationFn: async (payload: CreateUserPayload) => {
      const res: ApiResponse = await fetch5(`${url}/api/auth/reset/password?type=lmClient`, "PATCH", payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || 'Something went wrong';
      }

      return {...res.data, message: res.message};
    },
    onSuccess: (data) => {
      console.log('✅ OTP requested successfully:', data);
    },
    onError: (error: any) => {
      console.error('❌ OTP request failed:', error.message);
    }
  });
};

export const useForgotPasswordMutation = () => {
  return useMutation({
    mutationFn: async (payload: CreateUserPayload) => {
      const res: ApiResponse = await fetch5(`${url}/api/auth/password/change?type=lmClient`, "PATCH" ,payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || 'Something went wrong';
      }

      return {...res.data, message: res.message};
    },
    onSuccess: (data) => {
      console.log('✅ OTP requested successfully:', data);
    },
    onError: (error: any) => {
      console.error('❌ OTP request failed:', error.message);
    }
  });
};